import { render, staticRenderFns } from "./LettersEvents.vue?vue&type=template&id=a5d8d55a&scoped=true"
import script from "./LettersEvents.vue?vue&type=script&lang=js"
export * from "./LettersEvents.vue?vue&type=script&lang=js"
import style0 from "./LettersEvents.vue?vue&type=style&index=0&id=a5d8d55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d8d55a",
  null
  
)

export default component.exports